export default {
      id: "KRW-usage",
      viewBox: "0 0 20.4 22",
      url: __webpack_public_path__ + "img/svg.c2d72070.svg#KRW",
      toString: function () {
        return this.url;
      }
    }